var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import arrow from './../../../assets/images/svg/arrow-right.svg';
import { handleMouseMove } from '../../../constants/ButtonHover';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const validateEmail = (email) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
    };
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!validateEmail(email)) {
            toast.error('Please enter a valid email address.');
            setError('Please enter a valid email address.');
            return;
        }
        setError('');
        setIsLoading(true);
        try {
            const endpoint = process.env.NODE_ENV === 'development'
                ? '/api/v1/secure/new-subscriber'
                : `${process.env.NEWSLETTER_URL}/api/v1/secure/new-subscriber`;
            const response = yield fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.NEWSLETTER_API_KEY || '',
                    'X-Tunnel-Skip-Browser-Protection': 'true',
                },
                body: JSON.stringify({ email_address: email }),
            });
            const data = yield response.json();
            console.log(data, "response=============");
            if (data.success === true) {
                toast.success(data.message);
                setEmail('');
            }
            else {
                const msg = data.message || 'Something went wrong. Please try again.';
                toast.error(msg);
                setError(msg);
            }
        }
        catch (err) {
            toast.error('Failed to connect to the server. Please try again later.');
        }
        finally {
            setIsLoading(false);
        }
    });
    useEffect(() => {
        // Reset form on route change
        setEmail('');
        setError('');
    }, [location.pathname]);
    return (_jsxs("div", Object.assign({ className: "footer-newsletter", "data-aos": "fade-up" }, { children: [_jsxs("h4", { children: ["Subscribe to our ", _jsx("br", {}), "Newsletter"] }), _jsx("div", Object.assign({ className: "newsletter-grp" }, { children: _jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", Object.assign({ className: "newsletter-form" }, { children: [_jsx("input", { type: "email", placeholder: "@ Enter address", value: email, className: `${error ? 'input-error' : ''}`, onChange: (e) => setEmail(e.target.value), disabled: isLoading }), _jsx("button", Object.assign({ type: "submit", onMouseMove: handleMouseMove, className: "button", disabled: isLoading }, { children: isLoading ? _jsx("span", { className: "loader" }) : _jsx("img", { src: arrow, alt: "Arrow", width: "14", height: "13" }) }))] })), error && _jsx("p", Object.assign({ className: "error-text" }, { children: error }))] })) }))] })));
};
export default Newsletter;
